<!--@format-->
<template>
    <div class="opportunity-line-items-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Edit Line Items</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div class="table-wrapper">
                    <board
                        :loading="loading"
                        :pagination="pagination"
                        type="edit-line-items"
                        :headers="headers"
                        :items="lineItems"
                        :total-items="totalItems"
                        :sticky="true"
                    />
                    <div class="table-info">Edits only apply to this opportunity</div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn transparent-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button :disabled="!isValid" @click="save">Save Edits</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const Board = () => import('@/components/board/board.vue');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');

import EventBus from '@/scripts/event-bus.js';
import BoardUtility from '@/scripts/board-utility';

export default {
    name: 'opportunity-line-items-widget',
    components: {
        'app-button': AppButton,
        board: Board,
        'loading-screen-svg': LoadingScreenSvg,
        'widget-close-svg': WidgetCloseSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: true,
            lineItems: [],
            totalItems: 0,
            isValid: true,
            pagination: false,
            headers: BoardUtility.getHeaderDefinitions('line-items'),
        };
    },

    watch: {
        lineItems() {
            this.isValid = this.lineItems.every(
                ({ termInMonths, billingCycle }) =>
                    termInMonths !== 0 &&
                    termInMonths % this.$helpers.getTermInMonths(billingCycle) === 0
            );
        },
    },

    created() {
        this.mapLineItemsToTable();
        EventBus.$on('line-item:updated', this.updateLineItem);
    },

    beforeDestroy() {
        EventBus.$off('line-item:updated', this.updateLineItem);
    },

    methods: {
        updateLineItem(changes) {
            const { item, property, value } = changes;
            const updatedItem = {
                ...item,
                [property]: value,
                isModified: true,
            };

            if (property === 'billingCycle') {
                updatedItem.termInMonths = this.$helpers.getTermInMonths(value);
            }

            updatedItem.totalMargin = this.$helpers.calculateMargin(updatedItem);

            this.lineItems = this.lineItems.map((lineItem) =>
                lineItem.id === updatedItem.id ? updatedItem : lineItem
            );
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        save() {
            EventBus.$emit('line-items:saved', this.lineItems);
            EventBus.$emit('close-widget', this.widget);
        },

        mapLineItemsToTable() {
            setTimeout(() => {
                this.lineItems = this.widget.items.map((item) => ({
                    ...item.data,
                    solutionId: item.data.id,
                    id: item.id,
                    qty: item.qty,
                    termInMonths: item.termInMonths,
                    unitDiscount: item.unitDiscount,
                    totalMargin: item.totalMargin,
                    isModified: false,
                }));
                this.totalItems = this.lineItems.length;
                this.loading = false;
            }, 500);
        },
    },
};
</script>

<style>
.opportunity-line-items-widget .widget-contents-container .content-wrapper {
    padding: 0 35px;
}

.opportunity-line-items-widget .widget-contents-container .content-wrapper .table-wrapper {
    display: flex;
    flex-direction: column;
}

.opportunity-line-items-widget .widget-contents-container .content-wrapper .table-info {
    margin-top: 10px;
    font-weight: 500;
}

.opportunity-line-items-widget .content-wrapper .table-wrapper .board .board-view-options,
.opportunity-line-items-widget .content-wrapper .table-wrapper .board .board-pagination {
    display: none;
}

.opportunity-line-items-widget .content-wrapper .table-wrapper .board .string-cell {
    text-align: center;
}

.opportunity-line-items-widget .widget-contents-container .widget-footer .transparent-btn {
    background: transparent;
    color: #877d88;
    border: none;
}
.opportunity-line-items-widget .widget-contents-container .widget-footer .transparent-btn:hover {
    background: #e1e0e5;
}
</style>
